import { createContext, useContext } from 'react';
import { useJourneyExplorerApiService } from '../../../api/providers/AppServiceProvider';
import { IJourneyExplorerApiService } from '../../../api/services/journey-explorer-api-service';

export type JourneySource = 'website' | 'subscription';

export const JourneyApiContext = createContext<IJourneyExplorerApiService | null>(null);

export const useJourneyApi = (): IJourneyExplorerApiService => {
	const override = useContext(JourneyApiContext);
	const real = useJourneyExplorerApiService();
	return override ?? real;
};
